// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1bHNw","footer":"ModalUpdate_footer__1bkS3"};